"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment = require("moment");
const formatCurrency_1 = require("../../utils/format/formatCurrency");
const isApiErrorResponse_1 = require("../../utils/typeguards/isApiErrorResponse");
const validateGiftCode = (smavestoCore, code, source, paymentAmount, theme, supplierId) => __awaiter(void 0, void 0, void 0, function* () {
    const giftCodeCollection = yield smavestoCore.services.contentManagement.getGiftCodesFromPrismic();
    if ((0, isApiErrorResponse_1.default)(giftCodeCollection)) {
        return giftCodeCollection;
    }
    const foundElement = giftCodeCollection.documents.find(c => c.data.code === code.toLowerCase().trim() && c.data.active);
    if (!foundElement)
        return {
            hasResponse: false,
            error: true,
            humanReadableError: "Der eingegebene Code ist nicht korrekt.",
            key: "core.giftcode.notfound"
        };
    if (foundElement.data.theme && theme.key !== foundElement.data.theme)
        return {
            hasResponse: false,
            error: true,
            humanReadableError: "Der eingegebene Code ist nicht korrekt.",
            key: "core.giftcode.notValidForTheme"
        };
    if (foundElement.data.supplierids.length > 0 && !supplierId)
        return {
            hasResponse: false,
            error: true,
            humanReadableError: "Der eingegebene Code ist nicht korrekt.",
            key: "core.giftcode.notValidForTheme"
        };
    if (foundElement.data.supplierids.length > 0 &&
        supplierId &&
        !foundElement.data.supplierids.some(sid => sid.supplierid === supplierId))
        return {
            hasResponse: false,
            error: true,
            humanReadableError: "Der eingegebene Code ist nicht korrekt.",
            key: "core.giftcode.notValidForTheme"
        };
    if (foundElement.data.limit && source !== foundElement.data.limit)
        return {
            hasResponse: false,
            error: true,
            humanReadableError: "Der eingegebene Code ist nicht korrekt.",
            key: "core.giftcode.notValidForSource"
        };
    if (foundElement.data.startdate &&
        moment(new Date()).isBefore(moment(foundElement.data.startdate)))
        return {
            hasResponse: false,
            error: true,
            humanReadableError: `Der eingegebene Code ist noch nicht gültig.`,
            key: "core.giftcode.expired"
        };
    if (moment(new Date()).isAfter(moment(foundElement.data.enddate)))
        return {
            hasResponse: false,
            error: true,
            humanReadableError: `Der eingegebene Code ist abgelaufen.`,
            key: "core.giftcode.expired"
        };
    if (paymentAmount < (foundElement.data.minpayment || 0))
        return {
            hasResponse: false,
            error: true,
            humanReadableError: `Der eingegebene Code ist nur für ${source === "onboarding" ? "einen Startbetrag" : "eine Einzahlung"} in Höhe von mindestens ${(0, formatCurrency_1.default)(foundElement.data.minpayment || 0)} gültig.`
        };
    return foundElement;
});
exports.default = validateGiftCode;
